module.exports = __webpack_public_path__ + "static/civicAlliance-17c64bd96444287e6cb2e2adf64eb994.png";